export enum EEntityMode {
  Default,
  Shared,
  Single
}
